<div class="online-task-inspection-page">
  <div class="header-section">
    <a href="https://klobal.cz" target="_blank" class="logo-link logo-link--klobal">
      <img src="/assets/img/logo-white.png" alt="Pojišťovna Klobal logo" class="logo">
    </a>
    <a href="https://vyresimeskodu.cz" target="_blank" class="logo-link logo-link--vyresime-skodu">
      <img src="/assets/img/vyresime-skodu/logo-positive.svg" alt="Vyřešíme škodu logo" class="logo">
    </a>
  </div>
  <section class="main-container">
    <router-outlet></router-outlet>
  </section>

  <div class="contact-section">
    <div class="container">
      <div class="row">
        <div class="col-md-12 contact-title">
          <h3>Kontakt:</h3>
        </div>

        <div class="col-md-4">
          <div class="card mat-elevation-z5 mt-3">
            <div class="card-title row">
              <div class="md-12">
                Kontaktujte nás
              </div>
            </div>
            <div class="card-content row">
              <div class="md-12">
                <span>{{companyInfo.name}}</span><br>
                <span>{{companyInfo.phone}}</span><br>
                <span>{{companyInfo.email}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card mat-elevation-z5 mt-3">
            <div class="card-title row">
              <div class="col-12">
                O společnosti
              </div>
            </div>

            <div class="card-content row">
              <div class="col-md-6">
                <span>{{companyInfo.name}}</span><br>
                <span>{{companyInfo.address1}}</span><br>
                <span>{{companyInfo.address2}}</span>
              </div>

              <div class="col-md-6">
                <span>IČ: {{companyInfo.companyId}}</span><br>
                <span>DIČ: {{companyInfo.vatId}}</span><br>
                <span *ngIf="companyInfo.cnbLicense">ČNB: {{companyInfo.cnbLicense}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
